export const urlHeader = 'https://glaucoma.com.tw/glaucoma_chart/backend/api/';
export const LogInURL = "https://glaucoma.com.tw/login.html";
